<template>
<div class="perusahaan">
               
  <vue-perfect-scrollbar class="chat-history--scrollbar">
    <v-divider></v-divider>
    <v-list two-line class="chat-contact--list">

      <!-- Table Start -->

      <v-flex lg12 md12>
        <v-toolbar card color="white">
          <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Type something"
          v-model="search"
          hide-details
          class="hidden-sm-and-down"
          ></v-text-field>

          <!-- <v-btn color="primary" form="tambahkan-Lahan" @click="tambahkanLahan"><v-icon>add</v-icon><h5>Tambahkan Pesanan Pengiriman</h5></v-btn> -->
     
        </v-toolbar>
  
        <v-divider></v-divider>
  
        <v-data-table
          :headers="complex.headers"
          :search="search"
          :items="complex.items"
          :rows-per-page-items="[15,25,50,{text:'All','value':-1}]"
          class="elevation-1 data-fonts"
          item-key="name"
          v-model="complex.selected"
          >
          <template slot="items" slot-scope="props">
            <td class="data-fonts">{{ props.item.kodePenjualan }}</td>
            <td class="data-fonts">{{ props.item.status }}</td>
            <td class="data-fonts">{{ props.item.pelanggan }}</td>
            <td class="data-fonts">{{ props.item.penyediaJasaPengiriman }}</td>
            <td class="data-fonts">{{ props.item.tanggalBerlaku }}</td>
            <td class="data-fonts">{{ props.item.pengirim }}</td>
            <td class="data-fonts">{{ props.item.penjemputan }}</td>
            <td class="data-fonts">{{ props.item.penerima }}</td>
          </template>
        </v-data-table>
      </v-flex>  

      <!-- Table End -->
      
    </v-list>  
  </vue-perfect-scrollbar>  
</div>
</template>

<script>
import { getPesananPengiriman } from '@/api/pesananPengiriman';
import { Items as Users } from '@/api/pesananPengiriman';

import VCircle from '@/components/circle/VCircle';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VWidget from '@/components/VWidget';

export default {
  components: {
    VuePerfectScrollbar,
    VCircle,
    VWidget
  },

  data: () => ({ 
  }),

  data () {
    return {
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'Kode Penjualan',
            value: 'kodePenjualan'
          },
          {
            text: 'Status',
            value: 'status'
          },
          {
            text: 'Pelanggan',
            value: 'pelanggan'
          },
          {
            text: 'Penyedia Pengiriman',
            value: 'penyediaJasaPengiriman'
          },
          {
            text: 'Tanggal Berlaku',
            value: 'tanggalBerlaku'
          },
          {
            text: 'Pengirim',
            value: 'pengirim'
          },
          {
            text: 'Penjemputan',
            value: 'penjemputan'
          },
          {
            text: 'Penerima',
            value: 'penerima'
          },


          // {
          //   text: 'Pengiriman',
          //   value: 'pengiriman'
          // },
          // {
          //   text: 'Komoditas',
          //   value: 'komoditas'
          // },
          // {
          //   text: 'Kuantitas',
          //   value: 'kuantitas'
          // },
          // {
          //   text: 'Dibuat Pada',
          //   value: 'dibuatPada'
          // },
        ],
        items: Users,
      },
      role: localStorage.userEmail,
    };
  },

  computed: {
    users () {
      return getPesananPengiriman();
    }
  },

  methods: {

    initialize(){
      this.items = Users;
      console.log("Cek Items : ", this.items);
    },

    deleteItem (item) {
      // const index = this.items.indexOf(item);
      console.log("Item Succesfully Deleted");
    },

    tambahkanGapoktan(){
      window.getApp.$emit('APP_TAMBAHKAN_GAPOKTAN');
    },

    tambahkanLahan(){
      window.getApp.$emit('APP_TAMBAHKAN_GAPOKTAN_LAHAN');
    },

    editGapoktan (id) {
      return '/edit-perusahaan/' + id;
    },

    firstLetter (name) {
      return name.charAt(0);
    },

    userStatusColor (item) {
      return (item.active) ? 'green' : 'grey';
    }    
  }  
};
</script>

<style scoped>
  .data-fonts{
    font-size: 1em;
  }
</style>
